var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuzhi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.88193,
    y: 0.0626831,
    width: 15.8746,
    height: 1.76385,
    transform: "rotate(90 8.88193 0.0626831)",
    fill: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuzhi);
export default __webpack_public_path__ + "static/media/shuzhi.b0127ea968c742ae6cc5fb646e884055.svg";
export { ForwardRef as ReactComponent };